import {SvedTargetObject} from './svedTargetObject.model';

export class SvedTargetType {
  svedTarget = new SvedTargetObject();
}
